export default class DialysOffForm{
    recordTime:string
    recipeId:number
    systolicPressure:number
    diastolicPressure:number
    respiratoryRate:number
    heartRate:number
    bfv:number
    venousPressure:number
    arterialPressure:number
    transmembranePressure:number
    ufv:number
    ufr:number
    conductivity:number
    diaFlow:number
    diaTemperature:number
    constantVolume:number
    nxLevel:string = '0级'
    vaAssest:VaAssest = new VaAssest()
    remarks:string = '未诉不适'
}
class VaAssest{
    tremor:number = 0
    appearance:number = 0
    remarks:string
    imagePath:string
}


// WEBPACK FOOTER //
// ./src/views/dialysisProcess/dialysisArea/dialysisBeginForm.ts